// Wrapper around simple-git for the operations Avatar uses repeatedly.
// Centralised so error formatting and cwd handling stays consistent.
import { type SimpleGit, simpleGit } from "simple-git";

export function git(cwd: string = process.cwd()): SimpleGit {
  return simpleGit({ baseDir: cwd, binary: "git" });
}
